/* global app */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { SBPayments } from 'sb-payments'
import {bindActionCreators} from 'redux';
import {getCustomerDaysFromRegistration} from 'customerActions.js';
import CmsPage from 'CmsPage.js';

const { Payments, useSession } = SBPayments

const AccountDeposit = ({ isLogged,getCustomerDaysFromRegistration, isAccountAboveDaysLimitAndTemporary }) => {
  const session = useSession()
  // Watch for '2' which stands for MOBILE
  const [lang, setLang] = useState(() => `lang_${app.config.lang}_${app.config.mainCountryCode}_1_2`.toLowerCase())

  useEffect(() => {
    setLang(`lang_${app.config.lang}_${app.config.mainCountryCode}_1_2`.toLowerCase())
  }, [app.config, setLang])
  useEffect(() => {
    getCustomerDaysFromRegistration()
  },[]);
  return (
    isLogged && (
      <>
      <CmsPage name="deposit-main-banner-mobile" isPlaces={true} />
      <Payments lang={lang} session={session} shouldDepositButtonBeDisabled={isAccountAboveDaysLimitAndTemporary}/>
      </>
    )
  )
}

const mapStateToProps = ({ Auth: { isLogged },Customer:{isAccountAboveDaysLimitAndTemporary} }) => {
  return {
    isLogged,
    isAccountAboveDaysLimitAndTemporary
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerDaysFromRegistration: bindActionCreators(getCustomerDaysFromRegistration, dispatch),
  }
};

export default connect(mapStateToProps,mapDispatchToProps)(AccountDeposit)
